import { GlobalToken } from 'antd';
import { EngineStatusCircle } from './styled';

export interface EngineStatusInfo {
  color: string;
  label: string;
}

interface EngineStatusProps {
  engineStatusInfo: EngineStatusInfo;
  title: string;
  token: Partial<GlobalToken>;
}

export const EngineStatus = ({ engineStatusInfo, title, token }: EngineStatusProps) => {
  return (
    <div className="engine-status-container">
      <div className="engine-status-title">{title}</div>
      <div className="engine-status-row">
        <EngineStatusCircle $color={engineStatusInfo.color} theme={{ token }} />
        <span className="engine-status-label">{engineStatusInfo.label}</span>
      </div>
    </div>
  );
};
